import { Link, useSearchParams } from 'react-router-dom'
import { PageHeader } from '../components/PageHeader'
import { EmptyState } from '../components/ui'
import { MergeDuplicatesWizard } from '../components/features/MergeDuplicatesWizard'
import { useCanOperate } from './PersonDuplicates'

/** `/directory/merge?persons=op-1,op-2` — the guided merge wizard (operator). */
export default function MergeDuplicatesPage() {
  const [params] = useSearchParams()
  const canOperate = useCanOperate()
  const persons = Array.from(
    new Set(
      (params.get('persons') ?? '')
        .split(',')
        .map((p) => p.trim())
        .filter(Boolean),
    ),
  )

  return (
    <div className="flex flex-col gap-6">
      <PageHeader section="Directory" title="Merge duplicates">
        <p className="tnum mt-1 text-xs text-ostrel-ink-muted">
          <Link to="/directory" className="hover:text-ostrel-gold">
            People
          </Link>
          {' / '}
          <Link to="/directory/duplicates" className="hover:text-ostrel-gold">
            Duplicates
          </Link>
          {' / '}Merge
        </p>
      </PageHeader>
      {!canOperate ? (
        <EmptyState title="Operators only" hint="Merging people needs the operator or admin role." />
      ) : persons.length < 2 ? (
        <EmptyState
          title="Pick at least two people"
          hint="Open a duplicate group from the duplicates list to merge it."
          action={
            <Link
              to="/directory/duplicates"
              className="text-[10px] font-semibold uppercase tracking-widest text-ostrel-gold hover:text-ostrel-accent"
            >
              Duplicates →
            </Link>
          }
        />
      ) : (
        <MergeDuplicatesWizard key={persons.join(',')} persons={persons} />
      )}
    </div>
  )
}
